import type { MotionProps } from 'framer-motion';

/*
 * Motion Link
 */
export const linkMotionProperties: MotionProps = {
  whileHover: { scale: 1.05 },
  whileTap: { scale: 0.9 },
};
